import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useColorModeValue,
  Spinner
} from "@chakra-ui/react";

import DefaultAuth from "layouts/auth/Default";
import Footer from "components/footer/FooterAuth";
import { BeetLogo } from "components/icons/Icons";
import illustration from "assets/img/auth/bg2.jpg";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";
import { getAPIEndpoint } from "views/config";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { logger } from "views/models/logging";
import { AUTH_ERROR_MSG } from "views/config";

function SignIn() {

  const textColor = useColorModeValue("navy.700", "white");
  const textColorSecondary = "gray.400";
  const brandStars = useColorModeValue("brand.500", "brand.400");
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);

  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [isBusy, setIsBusy] = useState(false);

  const btnLabel = 'Sign in';
  let history = useHistory();

  useEffect(() => {
    if (sessionStorage.getItem('clientInfo')) {
      sessionStorage.removeItem('clientInfo');
    }
  }, [])

  const authenticate = async () => {
    const params = {
      username: username,
      password: password
    };
    try {
      const response = await axios.post(getAPIEndpoint('auth'), params);
      if (response) {
        const { status, data, token } = response.data;
        if (status === 'success' && token) {
          sessionStorage.setItem('clientInfo', JSON.stringify(data[0]));
          sessionStorage.setItem('token', token);

          if (data[0].role === 'User')
            history.push('/admin');
          else {
            if (data[0].role === 'Admin')
              history.push('/admin/clientmgt');
          }

        }
        else {
          if (status === 'database_error')
            toast.error(AUTH_ERROR_MSG);
          else
            toast.error('Username or password is incorrect.');
        }
      }
      else
        toast.error(AUTH_ERROR_MSG);
    } catch (error) {
      toast.error(AUTH_ERROR_MSG);
      await logger({ task: "Sign in", error: error.toString() });
    }
    setIsBusy(false);
  }

  const processLogin = async (e) => {
    e.preventDefault();
    setIsBusy(true);
    await authenticate();
  }

  return (
    <>
      <DefaultAuth illustrationBackground={illustration} image={illustration}>
        <Flex
          maxW={{ base: "100%", md: "max-content" }}
          w='100%'
          mx={{ base: "auto", lg: "0px" }}
          me='auto'
          h='100%'
          alignItems='start'
          justifyContent='center'
          mb={{ base: "30px", md: "60px" }}
          px={{ base: "25px", md: "0px" }}
          mt={{ base: "40px", md: "14vh" }}
          flexDirection='column'>
          <Box me='auto' align='center' px='40px'>
            <BeetLogo h='40px' w='86px' mb='30px' />
            <Text
              mb='36px'
              ms='4px'
              color={textColorSecondary}
              fontWeight='400'
              fontSize='md'>
              Enter your email and password to sign in.
            </Text>
          </Box>
          <Flex
            zIndex='2'
            direction='column'
            w={{ base: "100%", md: "420px" }}
            maxW='100%'
            background='transparent'
            borderRadius='15px'
            mx={{ base: "auto", lg: "unset" }}
            me='auto'
            mb={{ base: "20px", md: "auto" }}>
            <form onSubmit={processLogin}>
              <FormControl>
                <FormLabel
                  display='flex'
                  ms='4px'
                  fontSize='md'
                  fontWeight='500'
                  color={textColor}
                  mb='8px'>
                  Email address<Text color={brandStars}>*</Text>
                </FormLabel>
                <Input
                  isRequired={true}
                  variant='auth'
                  fontSize='md'
                  ms={{ base: "0px", md: "0px" }}
                  type='email'
                  mb='24px'
                  fontWeight='500'
                  size='lg'
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
                <FormLabel
                  ms='4px'
                  fontSize='md'
                  fontWeight='500'
                  color={textColor}
                  display='flex'>
                  Password<Text color={brandStars}>*</Text>
                </FormLabel>
                <InputGroup size='md'>
                  <Input
                    isRequired={true}
                    fontSize='md'
                    placeholder=''
                    mb='24px'
                    size='lg'
                    type={show ? "text" : "password"}
                    variant='auth'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <InputRightElement display='flex' alignItems='center' mt='4px'>
                    <Icon
                      color={textColorSecondary}
                      _hover={{ cursor: "pointer" }}
                      as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                      onClick={handleClick}
                    />
                  </InputRightElement>
                </InputGroup>
                <Button
                  fontSize='md'
                  variant='brand'
                  fontWeight='500'
                  w='100%'
                  h='50'
                  mb='24px'
                  type='submit'
                >
                  {isBusy ? <Spinner /> : btnLabel}
                </Button>
              </FormControl>
            </form>
            <Flex
              flexDirection='column'
              justifyContent='center'
              alignItems='start'
              maxW='100%'
              mt='0px'>
              <Box py='200px'>
                <Footer />
              </Box>
            </Flex>
          </Flex>
        </Flex>
      </DefaultAuth>
      <ToastContainer />
    </>
  );
}

export default SignIn;
